import request from "@/utils/request";

export function getUsers(params) {
  return request({
    url: "/api/admin/users/",
    method: "get",
    params,
  });
}

export function getUser(id) {
  return request({
    url: `/api/admin/users/${id}/`,
    method: "get",
  });
}

export function createUser(data) {
  return request({
    url: "/api/admin/users/",
    method: "post",
    data,
  });
}

export function updateUser(id, data) {
  return request({
    url: `/api/admin/users/${id}/`,
    method: "patch",
    data,
  });
}
